module.exports = __webpack_public_path__ + "img/footer-symbol.1c3b4842.png";